module.exports = __webpack_public_path__ + "img/gv.f7e83cac.svg";